module.exports = __webpack_public_path__ + "img/add.2d7c6446.svg";